import "./radio.css.js";
const a = {
  modifiers: {
    standalone: "pf-m-standalone",
    disabled: "pf-m-disabled"
  },
  radio: "pf-v6-c-radio",
  radioBody: "pf-v6-c-radio__body",
  radioDescription: "pf-v6-c-radio__description",
  radioInput: "pf-v6-c-radio__input",
  radioLabel: "pf-v6-c-radio__label"
};
export {
  a as default
};
